(() => {
  const hostSelector = 'shopify-chat, shopify-agent';
  const shadowHostSelector = `${hostSelector}, shopify-agent-runtime, shopify-sign-in-button`;
  const iconStyleId = 'lece-shopify-inbox-icon-style';
  const signInStyleId = 'lece-shopify-inbox-sign-in-style';
  const iconStyles = `
    .activator__icon {
      width: calc(var(--private-activator-icon-size) * 2) !important;
      height: calc(var(--private-activator-icon-size) * 2) !important;
    }

    .activator__icon svg path {
      stroke-width: 0.6 !important;
    }
  `;
  const signInStyles = `
    .sign-in-button,
    .sign-in-button--shop,
    .sign-in-button--shop:hover:not(:active) {
      color: #ffffff !important;
      background-color: #000000 !important;
    }

    .sign-in-button:focus-visible,
    .sign-in-button--shop:focus-visible {
      outline-color: #000000 !important;
    }
  `;
  const observedRoots = new WeakSet();

  const customizeHost = (host) => {
    const shadowRoot = host.shadowRoot;

    if (!shadowRoot || shadowRoot.getElementById(iconStyleId)) return;

    const style = document.createElement('style');
    style.id = iconStyleId;
    style.textContent = iconStyles;
    shadowRoot.appendChild(style);
  };

  const customizeSignInButton = (button) => {
    const shadowRoot = button.shadowRoot;

    if (!shadowRoot || shadowRoot.getElementById(signInStyleId)) return;

    const style = document.createElement('style');
    style.id = signInStyleId;
    style.textContent = signInStyles;
    shadowRoot.appendChild(style);
  };

  const scanRoot = (root) => {
    if (!observedRoots.has(root)) {
      observer.observe(root, { childList: true, subtree: true });
      observedRoots.add(root);
    }

    root.querySelectorAll(shadowHostSelector).forEach((element) => {
      if (element.matches(hostSelector)) customizeHost(element);
      if (element.matches('shopify-sign-in-button')) customizeSignInButton(element);
      if (element.shadowRoot) scanRoot(element.shadowRoot);
    });
  };

  const customizeInbox = () => scanRoot(document);
  const observer = new MutationObserver(customizeInbox);

  ['shopify-chat', 'shopify-agent', 'shopify-agent-runtime', 'shopify-sign-in-button'].forEach((elementName) => {
    customElements.whenDefined(elementName).then(customizeInbox);
  });

  document.addEventListener('shopify-render', customizeInbox);
  customizeInbox();
})();
